/* global localStorage */

import React, { createContext, useEffect, useState } from 'react'
import jwt_decode from 'jwt-decode'
import { isEmpty, pick } from 'lodash'
import { useNavigate } from 'react-router-dom'
// import { toast } from "wc-toast";
import { apiGet, apiPost } from '../utils/apiFetch'
import apiPath from '../utils/apiPath'
import useToastContext from 'hooks/useToastContext'
// import io from "socket.io-client";
const AuthContext = createContext()

export default AuthContext

export const AuthProvider = ({ children }) => {
  const [settingsLogo, setSettingsLogo] = useState(() =>
    localStorage.getItem('settingsLogo')
      ? localStorage.getItem('settingsLogo')
      : null
  )
  const [user, setUser] = useState(() =>
    localStorage.getItem('token')
      ? jwt_decode(localStorage.getItem('token'))
      : null
  )
  const [tab, setTab] = useState('')
  const [config, setConfig] = useState({})
  const [defaultCountry, setDefaultCountry] = useState('')
  const [defaultCurrency, setDefaultCurrency] = useState('')

  //  let [toast, setToast] = useState({ type: 'success', message: 'Success' })
  const [sidebarStatus, setSidebarStatus] = useState(
    localStorage.getItem('sidebar')
  )
  const [pageName, setPageName] = useState(
    localStorage.getItem('pageName')
      ? localStorage.getItem('pageName')
      : 'Dashboard'
  )
  const navigate = useNavigate()
  const notification = useToastContext()
  const [loginMessage, setLoginMessage] = useState(
    'Admin details updated successfully.'
  )
  const updatePageName = name => {
    localStorage.setItem('pageName', name)
    setTab('')
    setPageName(name)
  }
  const [country, setCountry] = useState('')
  const getSettings = async () => {
    try {
      const res = await apiGet(apiPath.getSettings)
      if (res) {
        localStorage.setItem('settingsLogo', res?.data.results?.logo)
        localStorage.setItem('country', res?.data.results?.country)
        const tempcountry = localStorage.getItem('country')
        setCountry(tempcountry)
        setSettingsLogo(res?.data?.results?.logo)
      }
    } catch (error) {
      console.error('error:', error)

      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser()
      }
    }
  }
  //     useEffect(()=>{
  // getSettings()
  //     },[user])
  const loginUser = async body => {
    document.getElementById('loader').classList.remove('hidden')
    const { status, data } = await apiPost(
      apiPath.loginUser,
      pick(body, ['email', 'password'])
    )

    if (status === 200) {
      if (data.success) {
        const token = data?.results?.token || null
        const refresh_token = data?.results?.refresh_token || null
        localStorage.setItem('token', token)
        localStorage.setItem('refresh_token', refresh_token)
        localStorage.setItem('pageName', 'Dashboard')
        setPageName('Dashboard')
        setUser(jwt_decode(token))
        getSettings()
        getConfig()
        navigate('/dashboard')
        // console.error(jwt_decode(token))
        // toast.success(data.message);
      } else {
        notification.error(data.message)
      }
    } else {
      // toast.error("API Error");
    }
    document.getElementById('loader').classList.add('hidden')
  }
  const getConfig = async () => {
    const { status, data } = await apiGet(apiPath.getConfigApi)
    if (status === 200) {
      if (data.success) {
        setConfig(data?.results)
        if (!isEmpty(data?.results)) {
          if (data?.results?.country === 'Saudi') {
            setDefaultCountry('sa')
            setDefaultCurrency('SAR')
          } else if (data?.results?.country === 'UAE') {
            setDefaultCountry('ae')
            setDefaultCurrency('AED')
          } else {
            setDefaultCountry('in')
            setDefaultCurrency('INR')
          }
        }
      }
    }
  }

  const updateProfile = async data => {
    try {
      const res = await apiPost(apiPath.editProfile, data)
      if (res?.data?.success) {
        const token = res?.data?.results?.token || null
        const refresh_token = res?.data?.results?.refresh_token || null
        localStorage.setItem('token', token)
        setLoginMessage(res?.data?.message)
        // localStorage.setItem("login_message", res?.data?.message)
        localStorage.setItem('refresh_token', refresh_token)
        setUser(jwt_decode(token))
        notification.success(res?.data?.message)
      } else {
        // setLoginMessage(res?.data?.message)
        notification.error(res?.data?.message)
      }
    } catch (err) {
      console.error('err:', err)
    }
  }

  const handleSidebar = () => {
    const s1 = localStorage.getItem('sidebar')
    localStorage.setItem('sidebar', s1 == 'open' ? 'close' : 'open')
    setSidebarStatus(s1 == 'open' ? 'close' : 'open')
  }

  const logoutUser = () => {
    setUser(null)
    localStorage.removeItem('token')
    localStorage.removeItem('refresh_token')
    navigate('/login')
  }

  useEffect(() => {
    getConfig()
  }, [])
  const contextData = {
    user,
    tab,
    country,
    setCountry,
    setTab,
    loginUser,
    logoutUser,
    updateProfile,
    sidebarStatus,
    handleSidebar,
    pageName,
    updatePageName,
    loginMessage,
    settingsLogo,
    setSettingsLogo,
    config,
    defaultCountry,
    defaultCurrency
  }
  return (
    <AuthContext.Provider value={contextData}>{children}</AuthContext.Provider>
  )
}
